import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2, 3),
    background: theme.palette.background.section,
    borderRadius: 10,
    border: `1px solid ${theme.palette.primary.main}`,

    '& > p': {
      fontSize: '.9rem',
      [theme.breakpoints.up('lg')]: {
        fontSize: '1rem'
      }
    },
    [theme.breakpoints.up('lg')]: {
      boxShadow: 'none'
    }
  },
  titleContainer: {
    display: 'flex',
    [theme.breakpoints.up('lg')]: {
      width: 300
    }
  },
  title: {
    fontWeight: 600,
    fontSize: '1rem',
    flexGrow: 1,
    marginTop: theme.spacing(),
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main
  }
}))
